import { apiClient, API_CONFIG } from '../config/api'
import { Container, ContainerRequest, ContainerResponse } from '../types/container'

const BM = API_CONFIG.BM_BASE_URL

export const containerService = {
  async getContainers(): Promise<ContainerResponse> {
    const { data } = await apiClient.get(`${BM}/containers`)
    return data
  },

  async getContainer(id: number) {
    const { data } = await apiClient.get(`${BM}/containers/${id}`)
    return data as { success: boolean; data: Container }
  },

  async createContainer(container: ContainerRequest) {
    const clean = Object.fromEntries(
      Object.entries(container).filter(([k, v]) => k !== 'container_type' && v !== undefined && v !== null && v !== '')
    )
    const { data } = await apiClient.post(`${BM}/containers`, clean)
    return data as { success: boolean; data: Container }
  },

  async updateContainer(id: number, container: ContainerRequest) {
    const { data } = await apiClient.put(`${BM}/containers/${id}`, container)
    return data as { success: boolean; data: Container }
  },

  async deleteContainer(id: number) {
    const { data } = await apiClient.delete(`${BM}/containers/${id}`)
    return data as { success: boolean; message?: string }
  },

  async getCustomerContainers(customerId: number): Promise<ContainerResponse> {
    const { data } = await apiClient.get(`${BM}/customers/${customerId}/containers`)
    return data
  },

  async getContainerBalises(containerId: number) {
    const { data } = await apiClient.get(`${BM}/containers/${containerId}/balises`)
    return data as { success: boolean; data: any[]; total: number }
  },
}
